module.exports = __webpack_public_path__ + "static/media/mt-ut-img-10.6a05b866.webp";